import { EnvironmentProviders, Provider } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';

/**
 * Hook for the mock mode (docs/in-progress/KONZEPT-SPA-Mock-Modus.md). Empty in every real build.
 * The `mock` configuration of angular.json swaps this file for mock-providers.mock.ts, so the sample data
 * and the fake sign-in are only reachable from there and never end up in a production bundle.
 */
export const MOCK_PROVIDERS: Array<Provider | EnvironmentProviders> = [];
export const MOCK_INTERCEPTORS: HttpInterceptorFn[] = [];
